import React, { Component } from "react";
import { Row, Col, Button } from "react-bootstrap";
import { Form } from "react-bootstrap";
import { toast } from "react-toastify";
import { EnviarNotificacaoPush } from "../../providers/AdminProvider";

export default class NotificacoesPush extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: "",
      body: "",
    };
  }

  enviarNotificacao = async () => {
    const { title, body } = this.state;
    if (title && body) {
      let data = {
        message: {
          title,
          body,
        },
      };
      try {
        const res = await EnviarNotificacaoPush(data);
        toast.success("Notificação enviada com sucesso!");
        this.setState({ title: "", body: "" });
      } catch (error) {
        toast.success("Erro ao enviar notificação!");
      }
    } else {
      toast.error("Campos: Título e Mensagem são obrigatórios!");
    }
  };

  render() {
    return (
      <div style={{ margin: 10, marginLeft: 50, marginRight: 50 }}>
        <br></br>
        <Row>
          <Col md={9}>
            <h3>Enviar Notificações Push</h3>
          </Col>
        </Row>
        <br></br>
        <br></br>
        <Row>
          <Col md="6">
            <Form.Group>
              <Form.Label>Título *</Form.Label>
              <Form.Control
                value={this.state.title}
                type="text"
                placeholder="Titulo"
                onChange={(e) => {
                  this.setState({ title: e.target.value });
                }}
              />
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col md="6">
            <Form.Group>
              <Form.Label>Mensagem *</Form.Label>
              <Form.Control
                value={this.state.body}
                type="text"
                as="textarea"
                rows="3"
                placeholder="Mensagem"
                onChange={(e) => {
                  this.setState({ body: e.target.value });
                }}
              />
            </Form.Group>
          </Col>
        </Row>
        <br></br>
        <Row>
          <Col md="6" style={{ display: "flex", flexDirection: "row-reverse" }}>
            <Button
              variant="primary"
              onClick={() => {
                this.enviarNotificacao();
              }}
            >
              {"Enviar"}
            </Button>
          </Col>
        </Row>
        <br></br>
        <br></br>
      </div>
    );
  }
}
